import axios from "axios";

const backendURL = process.env.VUE_APP_STRAPI_URL;
const prefix = process.env.VUE_APP_STRAPI_PREFIX;

export async function httpGet(route) {
    const token = sessionStorage.getItem('token');
    const headers = { 'Authorization': `Bearer ${token}` }

    if (token && headers) {
        return axios.get(backendURL + prefix + route, { headers });
    }
    else {
        return axios.get(backendURL + prefix + route);
    }
}

export async function httpPost(route, body) {
    const token = sessionStorage.getItem('token');
    const headers = { 'Authorization': `Bearer ${token}` }

    return axios.post(backendURL + prefix + route, body, { headers });
}

export async function httpPut(route, body) {
    const token = sessionStorage.getItem('token');
    const headers = { 'Authorization': `Bearer ${token}` }

    return axios.put(backendURL + prefix + route, body, { headers });
}

export async function httpDelete(route) {
    const token = sessionStorage.getItem('token');
    const headers = { 'Authorization': `Bearer ${token}` }

    return axios.delete(backendURL + prefix + route, { headers });
}

export async function login(body) {
    return axios.post(backendURL + prefix + '/auth/local', body);
}

export async function register(body) {
    return axios.post(backendURL + prefix + '/auth/local/register', body);
}

export async function fileByMail(body) {
    const token = sessionStorage.getItem('token');
    const headers = { 'Authorization': `Bearer ${token}` }
    return axios.post(backendURL + prefix + '/cotizacion/file-by-mail', body, { headers });
}

export async function sendMail(body) {
    const token = sessionStorage.getItem('token');
    const headers = { 'Authorization': `Bearer ${token}` }
    return axios.post(backendURL + prefix + '/cotizacion/send-mail', body, { headers });
}